import { useTranslation } from "react-i18next";
import { formatCapacity } from "../../../../app/utils/functions/formatCapacity";
import { formatAmount } from "../../../../app/utils/functions/formatAmount";
import { useAppSelector } from "../../../../states/hooks";
import { selectMiners } from "../../../../states/minersState";
import { selectCurrentRound } from "../../../../states/currentRoundState";
import { selectSignumState } from "../../../../states/signumState";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";

export const PoolInfo = () => {
    const { t } = useTranslation();

    const miningData = useAppSelector(selectMiners);
    const {
        isLoading: isLoadingMiningData,
        miners,
        totalPhysicalCapacity,
        totalEffectiveCapacity,
        totalSharedCapacity,
    } = miningData;

    const currentRound = useAppSelector(selectCurrentRound);
    const { isLoading: isLoadingCurrentRound, networkInfo } = currentRound;

    const signumState = useAppSelector(selectSignumState);
    const { isLoading: isLoadingSignumState, price } = signumState;

    return (
        <Grid
            className="smPoolStats"
            container
            mx="auto"
            maxWidth={1080}
            p={2}
            direction="row"
            alignItems="stretch"
        >
            <PoolStat
                title={t("poolPhysical")}
                // @ts-ignore
                value={formatCapacity(totalPhysicalCapacity)}
                loading={isLoadingMiningData}
            />

            <PoolStat
                title="Effektive Kapazität"
                // @ts-ignore
                value={formatCapacity(totalEffectiveCapacity)}
                loading={isLoadingMiningData}
            />

            <PoolStat
                title="Shared Capacity"
                // @ts-ignore
                value={formatCapacity(totalSharedCapacity)}
                loading={isLoadingMiningData}
            />

            <PoolStat
                title={t("miner", { count: miners.length })}
                value={`${miners.length}`}
                loading={isLoadingMiningData}
            />

            <PoolStat
                title={t("blockHeight")}
                value={formatAmount(networkInfo.blockHeight)}
                loading={isLoadingCurrentRound}
            />

            <PoolStat
                title={t("priceUSD")}
                value={"$" + formatAmount(price)}
                loading={isLoadingSignumState}
            />

            <PoolStat
                title={t("networkSize")}
                value={networkInfo.difficulty}
                loading={isLoadingCurrentRound}
                wide
            />
        </Grid>
    );
};

interface PoolStatProps {
    title: string;
    value: string;
    wide?: boolean;
    loading?: boolean;
}

export const PoolStat = ({
    title,
    value,
    wide = false,
    loading = false,
}: PoolStatProps) => {
    return (
        <Grid
            item
            className={"smPoolStat" + (wide ? " smPoolStatWide" : "")}
            sx={{
                width: wide ? { xs: "100%", md: "50%" } : { xs: "50%", md: "33.333%", lg: "16.666%" },
            }}
        >
            <Typography
                variant="overline"
                color="textSecondary"
                width="100%"
            >
                {title}
            </Typography>

            {loading && <CircularProgress size={30} />}

            {!loading && (
                <Typography
                    variant="h5"
                    width="100%"
                    fontWeight={900}
                >
                    {value}
                </Typography>
            )}
        </Grid>
    );
};
